import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const TYPE_COLORS = { case_study: "#D95D39", module: "#0077B6", pedagogy: "#4C956C" };
const TYPE_LABEL = { case_study: "CASE STUDY", module: "MODULE", pedagogy: "PEDAGOGY" };

export default function KnowledgeHub() {
  const [q, setQ] = useState("");
  const [type, setType] = useState("all");
  const [domain, setDomain] = useState("all");
  const [facets, setFacets] = useState({ domains: [], types: [] });
  const [rows, setRows] = useState([]);

  useEffect(() => { api.get("/knowledge/facets").then(r => setFacets(r.data)); }, []);
  useEffect(() => {
    api.get("/knowledge", { params: { q: q || undefined, type, domain }}).then(r => setRows(r.data));
  }, [q, type, domain]);

  return (
    <div data-testid="knowledge-hub-module" className="space-y-6">
      <div className="border border-white/10 bg-[#13233F] p-5 grid grid-cols-1 md:grid-cols-12 gap-4">
        <input data-testid="knowledge-search" placeholder="Search titles, tags, summaries…"
               value={q} onChange={e=>setQ(e.target.value)}
               className="md:col-span-6 bg-navy border border-white/15 text-cream p-3 text-sm focus:outline-none focus:border-sage" />
        <select data-testid="knowledge-type" value={type} onChange={e=>setType(e.target.value)}
                className="md:col-span-3 bg-navy border border-white/15 text-cream p-3 text-sm font-mono-data">
          <option value="all">All types</option>
          {facets.types.map(t => <option key={t} value={t}>{TYPE_LABEL[t] || t}</option>)}
        </select>
        <select data-testid="knowledge-domain" value={domain} onChange={e=>setDomain(e.target.value)}
                className="md:col-span-3 bg-navy border border-white/15 text-cream p-3 text-sm font-mono-data">
          <option value="all">All domains</option>
          {facets.domains.map(d => <option key={d} value={d}>{d}</option>)}
        </select>
      </div>

      <div className="font-mono-data text-xs tracking-[0.25em] uppercase text-[#E8B298]">
        {rows.length} shared assets · reusable across the network
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
        {rows.map(k => (
          <div key={k.id} data-testid={`knowledge-card-${k.id}`}
               className="border border-white/10 bg-[#13233F] p-5 hover:border-[#E8B298]/40 transition-colors flex flex-col min-h-[240px]">
            <div className="flex items-center justify-between">
              <span className="text-[10px] font-mono-data uppercase tracking-[0.22em]" style={{color: TYPE_COLORS[k.type]}}>
                {TYPE_LABEL[k.type] || k.type}
              </span>
              <span className="font-mono-data text-[10px] text-cream/50">{k.year}</span>
            </div>
            <h3 className="font-serif-display text-xl leading-tight mt-3">{k.title}</h3>
            <div className="text-xs text-cream/50 mt-1">{k.author_institute}</div>
            <p className="mt-3 text-sm text-cream/75 leading-relaxed flex-1">{k.summary}</p>
            <div className="flex flex-wrap gap-1.5 mt-4">
              {k.tags.map(t => (
                <span key={t} className="text-[10px] font-mono-data uppercase tracking-[0.18em] px-2 py-0.5 bg-white/5 border border-white/10 text-cream/80">{t}</span>
              ))}
            </div>
            <div className="flex items-center justify-between border-t border-white/10 mt-4 pt-3">
              <div className="font-mono-data text-[10px] uppercase tracking-[0.18em] text-cream/50">Domain · {k.domain}</div>
              <div className="font-mono-data text-sm" style={{color: TYPE_COLORS[k.type]}}>⟳ {k.reuses}</div>
            </div>
          </div>
        ))}
      </div>

      {rows.length === 0 && (
        <div className="border border-white/10 bg-[#13233F] p-10 text-center text-cream/60 font-mono-data text-sm">
          No assets match these filters.
        </div>
      )}
    </div>
  );
}
